(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["xst-search-sidebar"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

    const open_btns = document.querySelectorAll(".js-search--open")
    const close_btns = document.querySelectorAll(".js-search--close")

    open_btns.forEach(btn => btn.addEventListener("click", function () {
        document.querySelector(".xst-search-sidebar").classList.toggle('open-search');
        document.querySelector(".xst-search-sidebar").style.display = "block";
        document.querySelector("body").style.overflow = "hidden";
    }))

    close_btns.forEach(btn => btn.addEventListener("click", function () {
        document.querySelector(".xst-search-sidebar").classList.toggle('open-search');
        document.querySelector("body").style.overflow = "visible";
        setTimeout(function () {
            document.querySelector(".xst-search-sidebar").style.display = "none";
        }, 500)
    }))
})

  } catch(e) { console.error(e); }
})();

})();
